import { Assets } from './Assets'

export const OtherLiabilities = ({ liabilities, handleOnClick }) => {
  const otherLiabilities = (liabilities || []).filter(
    (option) => option.subType === OtherLiabilities.targetCategory
  )
  return (
    <Assets
      assets={otherLiabilities}
      handleOnClick={handleOnClick}
      category={OtherLiabilities.targetCategory}
    />
  )
}
OtherLiabilities.targetCategory = 'otherliabilities'
